<template>
  <v-navigation-drawer
    permanent
    app
    class="app-nav-drawer"
    width="200"
    :rail="miniMenu"
    rail-width="65"
  >
    <template v-slot:prepend>
      <div class="app-page-list">
        <div class="d-flex align-center justify-space-between nav-header-item pr-1 pl-5 pb-1">
          <router-link :to="'/console'" class="pt-3">
            <img
              alt="Pikle Logo"
              :src="require('@/assets/logo.svg')"
              width="23"
            />
          </router-link>
          <v-icon class="mt-2" @click="miniMenu = !miniMenu">{{ miniMenu ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
        </div>
      </div>
    </template>
    <!-- <v-divider></v-divider> -->
    <v-list class="app-page-list last-group pa-0" density="compact" :prepend-gap="8">
      <div class="services-section-wrapper">

        <div class="nav-section">

          <v-list-item
              :to="{ name: 'App', params: { appId: currentAppId }}"
              exact
              title="Home"
              prepend-icon="mdi-home"
              rounded
              color="primary"
              class="top-level-item"
              @click="resetTopNav"
          >
          </v-list-item>          

        </div>

        <div class="nav-section">
          <v-hover v-if="currentTaxon && currentRouteName === 'AppTaxonOverview'">
            <template v-slot:default="{ isHovering, props }">
            <v-list-item
              v-bind="props"
              exact
              :to="{ name: 'AppPikleCategories', params: { appId: currentAppId }}"
              class="top-level-item last-item"
              :class="{'v-list-item--active': currentTaxon && (currentRouteName == 'AppTaxonOverview' || currentRouteName == 'AppTaxonGroupedOverview')}"
              @click="resetTopNav"
              :title="currentTaxon && !isHovering ? currentTaxon.name : 'Categories'"
              prepend-icon="mdi-shape"
              rounded
              color="primary"
            >
            </v-list-item>
            </template>
          </v-hover>
          <v-list-item
              v-else-if="currentTaxon && currentRouteName !== 'AppTaxonOverview'"
              exact
              :to="{ name: 'AppTaxonOverview', params: { appId: currentAppId, taxonId: currentTaxon.id }}"
              class="top-level-item last-item"
              :title="currentTaxon.name"
              prepend-icon="mdi-shape"
              rounded
              color="primary"
            >
          </v-list-item>
          <v-list-item
              v-else
              exact
              :to="{ name: 'AppPikleCategories', params: { appId: currentAppId }}"
              class="top-level-item last-item"
              @click="resetTopNav"
              :title="'Categories'"
              prepend-icon="mdi-shape"
              rounded
              color="primary"
            >
          </v-list-item>
        </div>

        <TransitionGroup name="fade-transition">
        <div class="nav-section mb-4" v-if="currentTaxon && (currentRouteName == 'AppTaxonOverview' || routeVisibleIn('AppPikleCategories'))">
          <v-list-item
            :to="{ name: 'AppTaxonAttributes', params: { appId: currentAppId, taxonId: currentTaxon.id }}"
            exact
            class="child-nav-item"
            title="Attributes"
            :prepend-icon="miniMenu ? 'mdi-table-column': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
          <v-list-item
            :to="{ name: 'AppTaxonCollections', params: { appId: currentAppId, taxonId: currentTaxon.id }}"
            exact
            class="child-nav-item"
            title="Collections"
            :prepend-icon="miniMenu ? 'mdi-tag-multiple': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>
        </TransitionGroup>

        <div class="nav-section">
          <v-list-item
            :to="{ name: 'AppCatalog', params: { appId: currentAppId }}"
            exact
            class="top-level-item"
            :class="{'v-list-item--active': currentRouteName == 'AppCatalogItem'}"
            @click="resetTopNav"
            title="Catalog"
            prepend-icon="mdi-format-list-bulleted-type"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>
      </div>

      <div class="nav-section-title" v-if="!miniMenu">Services</div>

      <div class="services-section-wrapper">

        <div v-if="currentApp && currentApp.canUseContentGeneration">
          <v-list-item
            :to="{ name: 'AppGenerateContent', params: { appId: currentAppId }}"
            exact
            class="service-item"
            @click="resetTopNav"
            title="Page Content"
            prepend-icon="mdi-auto-fix"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>
        <TransitionGroup name="fade-transition">
        <div class="nav-section mb-4" v-if="routeVisibleIn('AppGenerateContent') && (currentUserIsOwner || currentUserIsAdmin)">
          <v-list-item
            :to="{ name: 'AppGenerateContentTemplates', params: { appId: currentAppId }}"
            exact
            class="child-nav-item"
            title="Templates"
            :class="{'v-list-item--active': currentRouteName == 'EditCategoryTemplate'}"
            :prepend-icon="miniMenu ? 'mdi-file-document': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
          <v-list-item
            :to="{ name: 'AppGenerateContentPersonas', params: { appId: currentAppId }}"
            exact
            class="child-nav-item"
            title="Personas"
            :prepend-icon="miniMenu ? 'mdi-account-group': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>
        </TransitionGroup>

        <div class="nav-section">
          <v-list-item
            :to="{ name: 'AppComparison', params: { appId: currentAppId }}"
            exact
            class="service-item"
            @click="resetTopNav"
            title="Comparison"
            prepend-icon="mdi-compare-horizontal"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>

        <div class="nav-section mb-4" v-if="routeVisibleIn('AppComparison')">
          <v-list-item
            :to="{ name: 'AppComparisonAnalytics', params: { appId: currentAppId }}"
            exact
            class="child-nav-item"
            v-if="(currentUserIsOwner || currentUserIsSysAdmin)"
            title="Analytics"
            :prepend-icon="miniMenu ? 'mdi-poll': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>

        <div class="nav-section" v-if="currentApp && currentApp.canUseFiltering">
          <!-- <v-list-item
            :to="{ name: 'AppFiltering', params: { appId: currentAppId }}"
            exact
            class="service-item"
            @click="resetTopNav"
            :disabled="currentApp && !currentApp.canUseFiltering"
            title="Filtering"
            prepend-icon="mdi-filter-cog"
            rounded
            color="primary"
          >
          </v-list-item> -->

          <v-hover v-if="currentTaxon && currentRouteName === 'AppFilteringTaxonOverview'">
            <template v-slot:default="{ isHovering, props }">
            <v-list-item
              v-bind="props"
              exact
              :to="{ name: 'AppFiltering', params: { appId: currentAppId }}"
              class="top-level-item last-item"
              :class="{'v-list-item--active': currentTaxon && (currentRouteName == 'AppFilteringTaxonOverview')}"
              @click="resetTopNav"
              :title="currentTaxon && !isHovering ? currentTaxon.name : 'Filtering'"
              prepend-icon="mdi-filter"
              rounded
              color="primary"
            >
            </v-list-item>
            </template>
          </v-hover>
          <v-list-item
              v-else-if="currentTaxon && currentRouteName !== 'AppFilteringTaxonOverview'"
              exact
              :to="{ name: 'AppFilteringTaxonOverview', params: { appId: currentAppId, taxonId: currentTaxon.id }}"
              class="top-level-item last-item"
              :class="{'v-list-item--active': currentTaxon && (currentRouteName == 'AppFilteringTaxonOverview')}"
              :title="currentTaxon.name"
              prepend-icon="mdi-filter"
              rounded
              color="primary"
            >
          </v-list-item>
          <v-list-item
              v-else
              exact
              :to="{ name: 'AppFiltering', params: { appId: currentAppId }}"
              class="top-level-item last-item"
              @click="resetTopNav"
              :title="'Filtering'"
              prepend-icon="mdi-filter"
              rounded
              color="primary"
            >
          </v-list-item>
        </div>

        <!-- <div class="nav-section mb-4" v-if="currentTaxon && routeVisibleIn('AppFiltering')">
          <v-list-item
            :to="{ name: 'AppFiltering', params: { appId: currentAppId }}"
            exact
            class="child-nav-item"
            title="Pages"
            :prepend-icon="miniMenu ? 'mdi-web': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
        </div> -->

        <div class="nav-section mb-4" v-if="!currentTaxon && routeVisibleIn('AppFiltering')">
          <v-list-item
            :to="{ name: 'AppFilteringAnalytics', params: { appId: currentAppId }}"
            exact
            class="child-nav-item"
            v-if="(currentUserIsOwner || currentUserIsSysAdmin)"
            title="Analytics"
            :prepend-icon="miniMenu ? 'mdi-poll': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>

        <div v-if="currentApp && currentApp.canUseSearch === true">
          <v-list-item
            :to="{ name: 'AppSearch', params: { appId: currentAppId }}"
            exact
            class="service-item"
            @click="resetTopNav"
            title="Search"
            prepend-icon="mdi-magnify"
            rounded
            color="primary"
          >
          </v-list-item>
          
        </div>

        <div v-if="currentApp && currentApp.canUseAssistant === true">
          <v-list-item
              :to="{ name: 'AppAssistant', params: { appId: currentAppId }}"
              class="service-item"
              @click="resetTopNav"
              :disabled="currentApp && !currentApp.canUseAssistant"
              title="AI Assistant"
              prepend-icon="mdi-assistant"
              rounded
              color="primary"
            >
          </v-list-item>
        </div>

        <div v-if="currentApp && currentApp.canUseInsights === true">
          <v-list-item
            :to="{ name: 'AppMarketInsights', params: { appId: currentAppId }}"
            class="service-item"
            @click="resetTopNav"
            title="Market Insights"
            prepend-icon="mdi-chart-timeline-variant"
            rounded
            color="primary"
          >
          </v-list-item>
        </div>

        <div v-if="currentApp && currentApp.canUseLeads === true">
          <v-list-item
            :to="{ name: 'AppLeads', params: { appId: currentAppId }}"
            exact
            class="service-item"
            @click="resetTopNav"
            title="Customer Leads"
            prepend-icon="mdi-cursor-default-click"
            rounded
            color="primary"
          >
          </v-list-item>

          <v-list-item
            :to="{ name: 'AppLeadsAnalytics', params: { appId: currentAppId }}"
            exact
            class="child-nav-item"
            @click="resetTopNav"
            v-if="routeVisibleIn('AppLeads')"
            title="Analytics"
            :prepend-icon="miniMenu ? 'mdi-poll': 'mdi-placeholder'"
            rounded
            color="primary"
          >
          </v-list-item>
          
        </div>

      </div>

        <div class="nav-section-title" v-if="!miniMenu">Integration</div>

        <div class="services-section-wrapper">
          <div>
            <v-list-item
              :to="{ name: 'AppIntegration', params: { appId: currentAppId }}"
              exact
              class="top-level-item"
              @click="resetTopNav"
              title="Integration"
              prepend-icon="mdi-connection"
              rounded
              color="primary"
            >
            </v-list-item>

            <v-list-item
              :to="{ name: 'AppSecrets', params: { appId: currentAppId }}"
              exact
              class="top-level-item child"
              @click="resetTopNav"
              v-if="currentUserRolesInApp.indexOf(memberRoles.admin) > -1"
              title="API Keys"
              prepend-icon="mdi-shield-key"
              rounded
              color="primary"
            >
            </v-list-item>
          </div>
        </div>

        <div v-if="currentUserIsOwner">
          <v-list-item
            :to="{ name: 'AppSettings', params: { appId: currentAppId }}"
            exact
            @click="storeLastNonSettingsRoute(); resetTopNav; miniMenu = true;"
            class="top-level-item"
            title="Settings"
            prepend-icon="mdi-cog"
            color="primary"
            :class="{'v-list-item--active': routeVisibleIn('AppSettings')}"
          >
          </v-list-item>

          <!-- <v-list-item
            :to="{ name: 'AppBilling', params: { appId: currentAppId }}"
            exact
            class="top-level-item child"
            @click="resetTopNav"
            v-if="routeVisibleIn('AppSettings')"
            title="Billing"
            prepend-icon="mdi-file-document"
            rounded
            color="primary"
          >
          </v-list-item> -->
        </div>

      <!-- </v-list-item-group> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// Veux types
import * as DeveloperAppTypes from '../../store/types/apps'

import AuthUtil from '../../authUtil'

import { mapState } from 'vuex'


import pikleServiceStatusMixin from '@/mixins/ServiceStatusMixin.js'

import Constants from '../../constants.js'


export default {
  name: 'CurrentAppNav',
  mixins: [pikleServiceStatusMixin],
  props: {
  },
  data () {
    return {
      activeCategoryNav: [],
      activeComparisonCategoryNav: [],
      activeFilteringCategoryNav: [],
      openNavItems: [],
      openComparisonNavItems: [],
      openFilteringNavItems: [],
      miniMenu: false,
      routeHierarchy: {
        // AppPikleCategories: ['AppPikleCategoryEditor', 'AppTaxonOverview', 'AppPikleCategoryEditor', 'AppTaxonCatalogGrouped', 'AppTaxonFeatures', 'AppTaxonContentSettings'],
        // AppPikleCategories: ['AppTaxonOverview'],
        AppPikleCategories: ['AppTaxonAttributes', 'AppTaxonCollections', 'AppTaxonGroupedOverview'],
        AppGenerateContent: ['AppContentPage', 'AppGenerateContentTemplates', 'AppGenerateContentPersonas', 'EditCategoryTemplate'],
        AppComparison: ['AppComparisonTaxonOverview', 'AppComparisonTaxonCatalog', 'AppComparisonTaxonCatalogGrouped', 'AppComparisonTaxonFeatures', 'AppComparisonAnalytics'],
        AppFiltering: ['AppFilteringTaxonOverview', 'AppFilteringTaxonCatalog', 'AppFilteringTaxonCatalogGrouped', 'AppFilteringTaxonFeatures', 'AppFilteringAnalytics'],
        AppLeads: ['AppLeadsAnalytics'],
        AppIntegration: ['AppSecrets'],
        AppSettings: ['AppBilling', 'AppSettingsGeneral', 'AppFeedSettings', 'AppCompareBoardSettings', 'AppUserSettings']
      }
    }
  },
  computed: {
    ...mapState({
      userMetaData: state => state.user.metaData,
      currentApp: state => state.apps.currentApp,
      allServiceModes: state => state.apps.serviceModes,
      appCurrentTaxon: state => state.apps.currentTaxon,
      currentTaxonGroup: state => state.apps.currentTaxonGroup,
      currentTaxonGroupsMap: state => state.apps.currentTaxonGroups,
      currentAppNavExpansions: state => state.apps.currentAppNavExpansions
    }),
    currentRouteName () {
        return this.$route.name;
    },
    currentAppId () {
      return this.currentApp ? this.currentApp.id : null
    },
    currentUserID () {
      // return this.userMetaData ? this.userMetaData.uid : null
      return AuthUtil.auth.currentUser ? AuthUtil.auth.currentUser.uid : null;
    },
    currentUserIsOwner () {
      return this.currentApp ? this.currentApp.owner === this.currentUserID : false
    },
    currentUserIsSysAdmin () {
      return this.userMetaData ? this.userMetaData.isSysAdmin : false;
    },
    currentUserIsAdmin () {
      return this.currentUserRolesInApp.indexOf(this.memberRoles.admin) > -1;
    },
    currentUserRolesInApp () {
      let roles = []
      if (this.currentApp && this.currentApp.members && this.currentApp.members[this.currentUserID]) {
        roles = this.currentApp.members[this.currentUserID].roles
      } else if (this.currentUserIsOwner) {
        roles.push(...[this.memberRoles.owner, this.memberRoles.admin, this.memberRoles.editor])
      }
      return roles
    },
    memberRoles () {
      return Constants.MEMBER_ROLES
    },
    taxoNavItemsMap () {
      const items = {}

      this.taxonList.forEach((item) => {
        const taxonItem = {
          id: item.id,
          name: item.name,
          type: 'taxon',
          icon: 'mdi-circle-small',
        }

        // Current Taxon groups
        // if(this.currentTaxon && this.currentTaxon.id === item.id) {
        //   items[`${item.id}-products`] = {id: `${item.id}-products`, name: `Catalog`, routeName: 'AppPikleCategoryEditor', children: [], icon: 'mdi-format-list-bulleted-type'}
        //   items[`${item.id}-features`] = {id: `${item.id}-features`, name: 'Attributes', icon: 'mdi-table-column', routeName: 'AppTaxonFeatures'}
        //   // items[`${item.id}-testing`] = {id: `${item.id}-testing`, name: 'Test & Train', icon: 'mdi-test-tube', routeName: 'AppTaxonTraining'}
        //   items[`${item.id}-content`] = {id: `${item.id}-content`, name: 'Content Settings', icon: 'mdi-cog-transfer', routeName: 'AppTaxonContentSettings'}

        //   // items['products'] = {id: 'products', name: 'Catalog', routeName: 'AppTaxonEditor', children: [], icon: 'mdi-format-list-bulleted-type'}
        //   // items['features'] = {id: 'features', name: 'Features', icon: 'mdi-format-list-bulleted', routeName: 'AppTaxonFeatures'}
        //   // items['testing'] = {id: 'testing', name: 'Test & Train', icon: 'mdi-test-tube', routeName: 'AppTaxonTraining'}
        //   // items['content'] = {id: 'content', name: 'Content Settings', icon: 'mdi-cog-transfer', routeName: 'AppTaxonContentSettings'}

        //   this.currentTaxonGroups.forEach((group) => {
        //     const newGroupItem = {
        //       id: group.id,
        //       name: group.name,
        //       type: 'itemGroup'
        //     }
        //     items[group.id] = newGroupItem
        //   });

        // }

        items[item.id] = taxonItem
      });

      return items
    },
    currentTaxonNavItems () {
      const items = []
      if (this.currentTaxon) {
        const taxonItem = {
          id: this.currentTaxon.id,
          name: this.currentTaxon.name,
          type: 'taxon',
          children: []
        }
        const itemServiceMode = this.getTaxonServiceMode(this.currentTaxon.id)
        if (itemServiceMode) {
          taxonItem.class = itemServiceMode.id
        }

        // Current Taxon groups
        // taxonItem.children.push(...[
        //   {id: `${this.currentTaxon.id}-products`, name: 'Catalog', routeName: 'AppPikleCategoryEditor', children: [], icon: 'mdi-format-list-bulleted-type'},
        //   {id: `${this.currentTaxon.id}-features`, name: 'Attributes', icon: 'mdi-table-column', routeName: 'AppTaxonFeatures'},
        //   {id: `${this.currentTaxon.id}-content`, name: 'Content Settings', icon: 'mdi-cog-transfer', routeName: 'AppTaxonContentSettings'}
        // ])
        // this.currentTaxonGroups.forEach((group) => {
        //   const newGroupItem = {
        //     id: group.id,
        //     name: group.name,
        //     type: 'itemGroup'
        //   }
        //   if (group.ruleBased) {
        //     newGroupItem.icon = 'mdi-auto-fix'
        //   }
        //   taxonItem.children[0].children.push(newGroupItem)
        // });

        // if (taxonItem.children[0] && taxonItem.children[0].children) {
        //   taxonItem.children[0].children.sort((a, b) => {
        //     if(a.name < b.name) { return -1; }
        //     if(a.name > b.name) { return 1; }
        //     return 0;
        //   })
        // }


        items.push(taxonItem)
      }

      return items
    },
    // categoryNavItems () {
    //   const items = []
    //   this.taxonList.forEach((item) => {
    //     const taxonItem = {
    //       id: item.id,
    //       name: item.name,
    //       type: 'taxon',
    //       children: [],
    //       icon: 'mdi-circle-small'
    //     }
    //     const itemServiceMode = this.getTaxonServiceMode(item.id)
    //     if (itemServiceMode) {
    //       taxonItem.class = itemServiceMode.id
    //     }

    //     // Current Taxon groups
    //     if(this.currentTaxon && this.currentTaxon.id === item.id) {
    //       taxonItem.children = [
    //         {id: `${item.id}-products`, name: 'Comparable Items', routeName: 'AppTaxonEditor', children: [], icon: 'mdi-format-list-bulleted-type'},
    //         {id: `${item.id}-features`, name: 'Features', icon: 'mdi-format-list-bulleted', routeName: 'AppTaxonFeatures'},
    //         // {id: `${item.id}-testing`, name: 'Test & Train', icon: 'mdi-test-tube', routeName: 'AppTaxonTraining'},
    //         {id: `${item.id}-content`, name: 'Content Settings', icon: 'mdi-cog-transfer', routeName: 'AppTaxonContentSettings'}
    //         // {id: 'pikle-comparison', name: 'Comparison', icon: 'mdi-cog-transfer', routeName: 'AppTaxonComparison', children: [
    //         //   {id: 'pikle-comparison-training', name: 'Training', icon: 'mdi-brain', routeName: 'AppTaxonComparison'},
    //         //   {id: 'pikle-comparison-content', name: 'Refresh Settings', icon: 'mdi-web-sync', routeName: 'AppTaxonComparison'},
    //         //   {id: 'pikle-comparison-approve', name: 'Review/Approve', icon: 'mdi-check', routeName: 'AppTaxonComparison'}
    //         // ]},
    //       ]
    //       this.currentTaxonGroups.forEach((group) => {
    //         const newGroupItem = {
    //           id: group.id,
    //           name: group.name,
    //           type: 'itemGroup'
    //         }
    //         taxonItem.children[0].children.push(newGroupItem)
    //       });

    //       if (taxonItem.children[0] && taxonItem.children[0].children) {
    //         taxonItem.children[0].children.sort((a, b) => {
    //           if(a.name < b.name) { return -1; }
    //           if(a.name > b.name) { return 1; }
    //           return 0;
    //         })
    //       }

    //     }

    //     items.push(taxonItem)
    //   });

    //   return items
    // },
    comparableTaxonItemsMap () {
      const items = {}

      this.taxonList.forEach((item) => {
        const taxonItem = {
          id: item.id,
          taxonId: item.id,
          name: item.name,
          type: 'taxon',
          icon: 'mdi-circle-small',
        }
        const itemServiceMode = this.getTaxonServiceMode(this.currentApp, this.allServiceModes, item.id, 'comparison')
        if (itemServiceMode) {
          taxonItem.class = itemServiceMode.id
        }

        // Current Taxon groups
        // if(this.currentTaxon && this.currentTaxon.id === item.id) {
        //   items[`${item.id}-products`] = {id: `${item.id}-products`, taxonId: item.id, name: `Catalog`, routeName: 'AppComparisonTaxonCatalog', children: [], icon: 'mdi-format-list-bulleted-type'}
        //   items[`${item.id}-features`] = {id: `${item.id}-features`, taxonId: item.id, name: 'Attributes', icon: 'mdi-table-column', routeName: 'AppComparisonTaxonFeatures'}
        //   // items[`${item.id}-testing`] = {id: `${item.id}-testing`, name: 'Test & Train', icon: 'mdi-test-tube', routeName: 'AppTaxonTraining'}
        //   // items[`${item.id}-content`] = {id: `${item.id}-content`, name: 'Content Settings', icon: 'mdi-cog-transfer', routeName: 'AppTaxonContentSettings'}

        //   this.currentTaxonGroups.forEach((group) => {
        //     const newGroupItem = {
        //       id: `${group.id}`,
        //       groupId: group.id,
        //       name: group.name,
        //       type: 'itemGroup'
        //     }
        //     items[`${group.id}`] = newGroupItem
        //   });

        // }

        items[`${item.id}`] = taxonItem
      });

      return items
    },
    comparableTaxonNavItems () {
      const items = []
      if (this.currentTaxon) {
        // this.taxonList.forEach((item) => {
        const item = this.currentTaxon
        const taxonItem = {
          id: `${item.id}`,
          name: item.name,
          type: 'taxon',
          children: [],
          icon: 'mdi-circle-small'
        }
        const itemServiceMode = this.getTaxonServiceMode(this.currentApp, this.allServiceModes, item.id, 'comparison')
        if (itemServiceMode) {
          taxonItem.class = itemServiceMode.id
        }

          // Current Taxon groups
          // if(this.currentTaxon && this.currentTaxon.id === item.id) {
          //   taxonItem.children = [
          //     {id: `${item.id}-products`, name: 'Catalog', routeName: 'AppComparisonTaxonCatalog', children: [], icon: 'mdi-format-list-bulleted-type'},
          //     {id: `${item.id}-features`, name: 'Attributes', icon: 'mdi-table-column', routeName: 'AppComparisonTaxonFeatures'},
          //     // {id: `${item.id}-comparison-content`, name: 'Content Settings', icon: 'mdi-cog-transfer', routeName: 'AppTaxonContentSettings'}
          //   ]
          //   this.currentTaxonGroups.forEach((group) => {
          //     const newGroupItem = {
          //       id: `${group.id}`,
          //       groupId: group.id,
          //       name: group.name,
          //       type: 'itemGroup'
          //     }
          //     if (group.ruleBased) {
          //       newGroupItem.icon = 'mdi-auto-fix'
          //     }
          //     taxonItem.children[0].children.push(newGroupItem)
          //   });

          //   if (taxonItem.children[0] && taxonItem.children[0].children) {
          //     taxonItem.children[0].children.sort((a, b) => {
          //       if(a.name < b.name) { return -1; }
          //       if(a.name > b.name) { return 1; }
          //       return 0;
          //     })
          //   }

          // }

        items.push(taxonItem)
      }
      return items
    },
    filterableTaxonItemsMap () {
      const items = {}

      this.taxonList.forEach((item) => {
        const taxonItem = {
          id: `${item.id}`,
          taxonId: item.id,
          name: item.name,
          type: 'taxon',
          icon: 'mdi-circle-small',
        }
        const itemServiceMode = this.getTaxonServiceMode(this.currentApp, this.allServiceModes, item.id, 'filtering')
        if (itemServiceMode) {
          taxonItem.class = itemServiceMode.id
        }

        // Current Taxon groups
        // if(this.currentTaxon && this.currentTaxon.id === item.id) {
        //   items[`${item.id}-products`] = {id: `${item.id}-products`, taxonId: item.id, name: `Catalog`, routeName: 'AppFilteringTaxonCatalog', children: [], icon: 'mdi-format-list-bulleted-type'}
        //   items[`${item.id}-features`] = {id: `${item.id}-features`, taxonId: item.id, name: 'Attributes', icon: 'mdi-table-column', routeName: 'AppFilteringTaxonFeatures'}
        //   // items[`${item.id}-testing`] = {id: `${item.id}-testing`, name: 'Test & Train', icon: 'mdi-test-tube', routeName: 'AppTaxonTraining'}
        //   // items[`${item.id}-content`] = {id: `${item.id}-content`, name: 'Content Settings', icon: 'mdi-cog-transfer', routeName: 'AppTaxonContentSettings'}

        //   this.currentTaxonGroups.forEach((group) => {
        //     const newGroupItem = {
        //       id: `${group.id}`,
        //       groupId: group.id,
        //       name: group.name,
        //       type: 'itemGroup'
        //     }
        //     items[group.id] = newGroupItem
        //   });

        // }

        items[`${item.id}`] = taxonItem
      });

      return items
    },
    filterableTaxonNavItems () {
      const items = []
      if (this.currentTaxon) {
        // this.taxonList.forEach((item) => {
        const item = this.currentTaxon
        const taxonItem = {
          id: `${item.id}`,
          title: item.name,
          type: 'taxon',
          icon: 'mdi-circle-small',
          disabled: true
        }
        const itemServiceMode = this.getTaxonServiceMode(this.currentApp, this.allServiceModes, item.id, 'filtering')
        if (itemServiceMode) {
          taxonItem.class = itemServiceMode.id
        }

          // Current Taxon groups
          // if(this.currentTaxon && this.currentTaxon.id === item.id) {
          //   taxonItem.children = [
          //     {id: `${item.id}-products`, name: 'Catalog', routeName: 'AppFilteringTaxonCatalog', children: [], icon: 'mdi-format-list-bulleted-type'},
          //     {id: `${item.id}-features`, name: 'Attributes', icon: 'mdi-table-column', routeName: 'AppFilteringTaxonFeatures'},
          //   ]
          //   this.currentTaxonGroups.forEach((group) => {
          //     const newGroupItem = {
          //       id: `${group.id}`,
          //       groupId: group.id,
          //       name: group.name,
          //       type: 'itemGroup',
          //     }
          //     if (group.ruleBased) {
          //       newGroupItem.icon = 'mdi-auto-fix'
          //     }
          //     taxonItem.children[0].children.push(newGroupItem)
          //   });

          //   if (taxonItem.children[0] && taxonItem.children[0].children) {
          //     taxonItem.children[0].children.sort((a, b) => {
          //       if(a.name < b.name) { return -1; }
          //       if(a.name > b.name) { return 1; }
          //       return 0;
          //     })
          //   }

          // }

        items.push(taxonItem)
        // });
      }
      return items
    },
    currentTaxon: {
      // getter
      get: function () {
        return this.appCurrentTaxon
      },
      // setter
      set: function (newValue) {
        this.$store.dispatch(`apps/${DeveloperAppTypes.ACTION_SET_CURRENT_APP_TAXON}`, newValue)
      }
    },
    selectedTaxonGroup: {
      // getter
      get: function () {
        return this.currentTaxonGroup
      },
      // setter
      set: function (newValue) {
        this.$store.dispatch(`apps/${DeveloperAppTypes.ACTION_SET_CURRENT_APP_TAXON_GROUP}`, newValue)
      }
    },
    currentTaxonGroups() {
      let res = []
      if (this.currentTaxonGroupsMap) {
        res = Object.entries(this.currentTaxonGroupsMap).map(([key, value]) => { return {id: key, ...value} })
      }
      return res
    },
    taxonMap () {
      return this.currentApp ? this.currentApp.taxons : null;
    },
    taxonList () {
      const res = []
      Object.keys(this.taxonMap).forEach((key) => {
        const taxonItem = {
          id: key,
          name: this.taxonMap[key].name,
          criteria: this.taxonMap[key].criteria || {},
          itemsCount: this.taxonMap[key].itemsCount || 0
        }
        res.push(taxonItem)
      })
      // console.log(`taxonList = ${JSON.stringify(res)}`)
      return res
    }
  },
  mounted: function () {
    // this.activeCategoryNav = []
    // if (this.currentRouteName === 'AppTaxonComparison') {
    //   this.activeCategoryNav = ['comparison']
    // }
    // this.openNavItems = []
    // this.updateActiveNavItems(this.currentRouteName)
    // const groupId = this.$route.params.groupId
    // if (groupId) {
    //   console.log(`setting selected taxon group`)
    //   this.selectedTaxonGroup = groupId
    // }
  },
  watch: {
    currentTaxon: async function (newValue, oldValue) {
      // console.log(`Current taxon changed = ${JSON.stringify(newValue)}`)
      if (newValue) {
        if (!oldValue || newValue.id !== oldValue.id) {
          await this.$store.dispatch(`apps/${DeveloperAppTypes.FETCH_CURRENT_TAXON_GROUPS}`)
          if (this.currentApp && this.currentApp.canUseFiltering) {
            this.$store.dispatch(`apps/${DeveloperAppTypes.FETCH_CURRENT_TAXON_FILTERS}`)
          }
        }
        this.updateActiveNavItems(this.currentRouteName)
      }
    },
    selectedTaxonGroup: function (newValue, oldValue) {
      if (newValue && this.currentTaxon && newValue !== oldValue) {

        if (this.$route.name.indexOf('AppComparison') == 0) {
          this.activeComparisonCategoryNav = [this.selectedTaxonGroup]
          this.openComparisonNavItems.push(`${this.currentTaxon.id}-products`)  
        } else if (this.$route.name.indexOf('AppFiltering') == 0) {
          this.activeFilteringCategoryNav = [this.selectedTaxonGroup]
          this.openFilteringNavItems.push(`${this.currentTaxon.id}-products`)
        } else {
          this.activeCategoryNav = [this.selectedTaxonGroup]
          this.openNavItems.push(`${this.currentTaxon.id}-products`)
        }
      }
    },
    currentTaxonGroupsMap: function (newValue, oldValue) {
        if (newValue && this.selectedTaxonGroup && newValue !== oldValue) {

          if (this.$route.name.indexOf('AppComparison') == 0) {
            this.activeComparisonCategoryNav = [this.selectedTaxonGroup]
            this.openComparisonNavItems.push(`${this.currentTaxon.id}-products`)  
          } else if (this.$route.name.indexOf('AppFiltering') == 0) {
            this.activeFilteringCategoryNav = [this.selectedTaxonGroup]
            this.openFilteringNavItems.push(`${this.currentTaxon.id}-products`)
          } else {
            this.activeCategoryNav = [this.selectedTaxonGroup]
            this.openNavItems.push(`${this.currentTaxon.id}-products`)
          }
          // this.openNavItems.push(`${this.currentTaxon.id}-products`)
          // openComparisonNavItems
          // this.activeCategoryNav = [this.selectedTaxonGroup]
        
        }
    },
    currentRouteName: function (newValue) {
      this.updateActiveNavItems(newValue)
    }
  },
  methods: {
    updateActiveNavItems: function (routeName) {
      // Set root item expansion state
      if (this.routeHierarchy[routeName]) {
        // Is a root item so set the expansion state in the store
        this.$store.commit(`apps/${DeveloperAppTypes.MUTATION_SET_NAV_ITEM_EXPANDED}`, routeName)
      }
      if (this.currentTaxon) {
        
        if (this.$route.name.indexOf('AppComparison') == 0) {
          this.openComparisonNavItems = [this.currentTaxon.id]
          this.openFilteringNavItems = []
          this.openNavItems = []
          this.activeCategoryNav = []
          this.activeFilteringCategoryNav = []
        } else if (this.$route.name.indexOf('AppFiltering') == 0) {
          this.openFilteringNavItems = [this.currentTaxon.id]
          this.openComparisonNavItems = []
          this.openNavItems = []
          this.activeCategoryNav = []
          this.activeComparisonCategoryNav = []
        } else {
          this.openFilteringNavItems = []
          this.openComparisonNavItems = []
          this.openNavItems = [this.currentTaxon.id]
          this.activeComparisonCategoryNav = []
          this.activeFilteringCategoryNav = []
        }
        // this.openNavItems = []

        if (routeName) {
          if (this.selectedTaxonGroup) {
            if (this.$route.name.indexOf('AppComparison') == 0) {
              this.activeComparisonCategoryNav = [this.selectedTaxonGroup]
              this.openComparisonNavItems.push(`${this.currentTaxon.id}-products`)  
            } else if (this.$route.name.indexOf('AppFiltering') == 0) {
              this.activeFilteringCategoryNav = [this.selectedTaxonGroup]
              this.openFilteringNavItems.push(`${this.currentTaxon.id}-products`)
            } else {
              this.activeCategoryNav = [this.selectedTaxonGroup]
              this.openNavItems.push(`${this.currentTaxon.id}-products`)
            }

              // this.openNavItems.push(`${this.currentTaxon.id}-products`)
              // this.activeCategoryNav = [this.selectedTaxonGroup]

          }
          else if (routeName === 'AppTaxonOverview') {
            this.activeCategoryNav = [this.currentTaxon.id]
          }
          // else if (routeName === 'AppPikleCategoryEditor') {
          //   this.openNavItems.push(`${this.currentTaxon.id}`)
          //   this.activeCategoryNav = [`${this.currentTaxon.id}-products`]
          // }
          else if (routeName === 'AppTaxonComparison') {
            this.activeCategoryNav = ['comparison']
          }
          else if (routeName === 'AppComparisonTaxonOverview') {
            this.activeComparisonCategoryNav = [`${this.currentTaxon.id}`]
          }
          else if (routeName === 'AppTaxonFeatures') {
            this.activeCategoryNav = [`${this.currentTaxon.id}-features`]
          }
          else if (routeName === 'AppTaxonContentSettings') {
            this.activeCategoryNav = [`${this.currentTaxon.id}-content`]
          }
          else if (routeName === 'AppTaxonTraining') {
            this.activeCategoryNav = [`${this.currentTaxon.id}-testing`]
          }
          
          else if (routeName === 'AppComparisonTaxonCatalog') {
            this.openComparisonNavItems.push(`${this.currentTaxon.id}`)
            this.activeComparisonCategoryNav = [`${this.currentTaxon.id}-products`]
          }
          else if (routeName === 'AppComparisonTaxonFeatures') {
            this.openComparisonNavItems.push(`${this.currentTaxon.id}`)
            this.activeComparisonCategoryNav = [`${this.currentTaxon.id}-features`]
          }

          else if (routeName === 'AppFilteringTaxonOverview') {
            this.activeFilteringCategoryNav = [`${this.currentTaxon.id}`]
          }
          else if (routeName === 'AppFilteringTaxonCatalog') {
            this.openFilteringNavItems.push(`${this.currentTaxon.id}`)
            this.activeFilteringCategoryNav = [`${this.currentTaxon.id}-products`]
          }
          else if (routeName === 'AppFilteringTaxonFeatures') {
            this.openFilteringNavItems.push(`${this.currentTaxon.id}`)
            this.activeFilteringCategoryNav = [`${this.currentTaxon.id}-features`]
          }

          else if (routeName === 'AppTaxonItemEditor') {
            this.openNavItems.push(`${this.currentTaxon.id}-products`)
            if (this.selectedTaxonGroup) {
              this.activeCategoryNav = [this.selectedTaxonGroup]
            }
            // else {
            //   this.activeCategoryNav = ['products']
            // }
          }
          else if (routeName === 'AppComparisonAnalytics') {
            this.activeCategoryNav = []
            this.activeComparisonCategoryNav = []
            this.activeFilteringCategoryNav = []
          }

        }
      }
    },
    comparisonCategoryNavChanged: function (newActiveIdsArray) {
      const newActiveArray = []
      newActiveIdsArray.forEach((itemId) => {
        const navItem = this.comparableTaxonItemsMap[itemId]
        if (navItem) {
          newActiveArray.push(navItem)
        }
      });

      if (newActiveArray && newActiveArray.length > 0 && this.taxonList) {
        const firstActive = newActiveArray[0]
        
        const taxonItem = this.taxonList.find(item => item.id === firstActive.taxonId) || this.currentTaxon
        if (firstActive.type === 'taxon' && taxonItem && this.$route.name !== 'AppComparisonTaxonOverview') {
          this.selectedTaxonGroup = null
          if (!this.currentTaxon || this.currentTaxon.id !== taxonItem.id) {
            this.currentTaxon = taxonItem;
          }
          this.$router.push({ name: 'AppComparisonTaxonOverview', params: { appId: this.currentApp.id, taxonId: taxonItem.id } })
        }
        else if (firstActive.type === 'itemGroup' && this.currentTaxonGroupsMap) {
          if (this.selectedTaxonGroup !==  firstActive.groupId || this.currentRouteName !== 'AppComparisonTaxonCatalogGrouped') {
            this.selectedTaxonGroup = firstActive.groupId
            this.$router.push({ name: 'AppComparisonTaxonCatalogGrouped', params: { appId: this.currentApp.id, taxonId: this.currentTaxon.id, groupId: this.selectedTaxonGroup } })
          }
        } 
        else if (firstActive.routeName && taxonItem) {
          this.selectedTaxonGroup = null
          if (firstActive.routeName !== this.currentRouteName) {
            const routeChange = { name: firstActive.routeName, params: { appId: this.currentApp.id, taxonId: taxonItem.id } }
            if (firstActive.query) {
              routeChange.query = firstActive.query
            }
            this.$router.push(routeChange)
          }
        }
      }
    },
    filteringCategoryNavChanged: function (newActiveIdsArray) {
      const newActiveArray = []
      
      newActiveIdsArray.forEach((itemId) => {
        const navItem = this.filterableTaxonItemsMap[itemId]
        if (navItem) {
          newActiveArray.push(navItem)
        }
      });

      if (newActiveArray && newActiveArray.length > 0 && this.taxonList) {
        const firstActive = newActiveArray[0]
        
        const taxonItem = this.taxonList.find(item => item.id === firstActive.taxonId) || this.currentTaxon
        
        if (firstActive.type === 'taxon' && taxonItem && this.$route.name !== 'AppFilteringTaxonOverview') {
          this.selectedTaxonGroup = null
          if (!this.currentTaxon || this.currentTaxon.id !== taxonItem.id) {
            this.currentTaxon = taxonItem;
          }
          this.$router.push({ name: 'AppFilteringTaxonOverview', params: { appId: this.currentApp.id, taxonId: taxonItem.id } })
        }
        else if (firstActive.type === 'itemGroup' && this.currentTaxonGroupsMap) {
          if (this.selectedTaxonGroup !==  firstActive.groupId || this.currentRouteName !== 'AppFilteringTaxonCatalogGrouped') {
            this.selectedTaxonGroup = firstActive.groupId
            this.$router.push({ name: 'AppFilteringTaxonCatalogGrouped', params: { appId: this.currentApp.id, taxonId: this.currentTaxon.id, groupId: this.selectedTaxonGroup } })
          }
        } 
        else if (firstActive.routeName && taxonItem) {
          
          this.selectedTaxonGroup = null
          if (firstActive.routeName !== this.currentRouteName) {
            
            const routeChange = { name: firstActive.routeName, params: { appId: this.currentApp.id, taxonId: taxonItem.id } }
            if (firstActive.query) {
              routeChange.query = firstActive.query
            }
            this.$router.push(routeChange)
          }
        }
      }
    },
    categoryNavChanged: function (newActiveIdsArray) {
      const newActiveArray = []
      newActiveIdsArray.forEach((itemId) => {
        const navItem = this.taxoNavItemsMap[itemId]
        if (navItem) {
          newActiveArray.push(navItem)
        }
      });

      if (newActiveArray && newActiveArray.length > 0) {
        const firstActive = newActiveArray[0]
        // console.log(`firstActive = ${JSON.stringify(firstActive)}`)
        if (firstActive.type === 'taxon' && this.taxonList) {
          const taxonItem = this.taxonList.find(item => item.id === firstActive.id)
          // console.log(`Should nav to ${JSON.stringify(taxonItem)}`)
          this.navigateToTaxon(taxonItem)
        } else if (firstActive.type === 'itemGroup' && this.currentTaxonGroupsMap) {
          if (this.selectedTaxonGroup !==  firstActive.id || this.currentRouteName !== 'AppTaxonCatalogGrouped') {
            this.selectedTaxonGroup = firstActive.id
            this.$router.push({ name: 'AppTaxonCatalogGrouped', params: { appId: this.currentApp.id, taxonId: this.currentTaxon.id, groupId: this.selectedTaxonGroup } })
          }
        } else if (firstActive.routeName && this.currentTaxon) {
          this.selectedTaxonGroup = null
          if (firstActive.routeName !== this.currentRouteName) {
            const routeChange = { name: firstActive.routeName, params: { appId: this.currentApp.id, taxonId: this.currentTaxon.id } }
            if (firstActive.query) {
              routeChange.query = firstActive.query
            }
            this.$router.push(routeChange)
          }
        }
      }
    },
    resetTopNav: function () {
      this.activeCategoryNav = []
      this.activeComparisonCategoryNav = []
      this.activeFilteringCategoryNav = []
      this.selectedTaxonGroup = null
      this.currentTaxon = null
    },
    navigateToTaxon: function (taxon) {
      if (!taxon) return;
      this.selectedTaxonGroup = null
      if (!this.currentTaxon || this.currentTaxon.id !== taxon.id) {
        this.currentTaxon = taxon;
      }
      if (this.$route.name !== 'AppTaxonOverview') {
        // console.log(`navigateToTaxon params = ${JSON.stringify({ appId: this.currentApp.id, taxonId: taxon.id })}`)
        this.$router.push({ name: 'AppTaxonOverview', params: { appId: this.currentApp.id, taxonId: taxon.id } })
      }
    },
    routeVisibleIn: function (rootRoute) {
      // Return true if the current route is the given rootRoute, or it was previousely expanded
      // if (this.currentRouteName === rootRoute || this.currentAppNavExpansions[rootRoute]) {
      if (this.currentRouteName === rootRoute) {
        return true;
      } else {
        // Check if current route is a sibling of the item (has the same rootRoute)
        return this.routeHierarchy[rootRoute] && this.routeHierarchy[rootRoute] ? this.routeHierarchy[rootRoute].includes(this.currentRouteName) : false;
      }
    },
    storeLastNonSettingsRoute: function () {
      // this.$store.commit(types.MUTATION_SET_LAST_NON_SETTINGS_ROUTE, {name: this.$route.name, params: this.$route.params}) 
      this.$store.commit(`apps/${DeveloperAppTypes.MUTATION_SET_LAST_NON_SETTINGS_ROUTE}`, {name: this.$route.name, params: this.$route.params})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.nav-section {
  .v-treeview-node__root {
    
    padding-left: 18px !important;
    cursor: pointer;

    .v-treeview-node__level {
      width: 8px;
    }
  }

  .v-treeview-node--leaf {
    cursor: pointer;
  }

  .tree-nav {
    border-top: none;

    .v-treeview-item__level {
      width: 20px;
    }
  }
}

.app-nav-drawer {
  border-right: none !important;
}

.app-nav-drawer.v-navigation-drawer > .v-navigation-drawer__border {
  display: none
}
</style>

<style scoped lang="scss">

.taxon-status-icon {

  margin-right: 10px;
  
  &.disabled {
    color: #f44336;
  }
  &.testing {
    color: #c44bc4;
  }
  &.enabled {
    color: #4caf50;
  }
}

.app-page-list {

  &.last-group {
    padding-bottom: 100px !important;
  }

  .nav-section-title {
    margin: 20px 15px 5px 23px;
    color: #758a9c;
    font-size: 0.9rem;
  }

  .services-section-wrapper {
    margin: 0px 0px 40px 0px;
    // border-radius: 5px;
    // border-top: 1px solid rgb(135, 135, 135);
    // border-bottom: 1px solid rgb(135, 135, 135);
    overflow: hidden;
    // background-color: rgba(126, 126, 126) !important;

    // .v-list-item {
    //   border-radius: 8px;
    //   background-color: #f6f7f9;
    //   border: 1px solid #e0e0e0;
    //   margin-top: 5px;
    // }
  }

  .service-item {
    // background-color: rgba(0, 14, 44, 0.7) !important;
    margin-top: 1px;
    // border-top:  1px solid gb(135, 135, 135);
    padding-top: 5px;
    padding-bottom: 5px;

    padding-left: 20px;
    padding-right: 25px;

    // &.outer {
    //   padding-left: 20px;
    //   padding-right: 25px;
    // }
  }

  .top-level-item {

    margin-top: 0px;
    padding-left: 20px;
    padding-right: 25px;

    // &.last-item {
    //   border-bottom: 1px solid rgb(135, 135, 135);
    // }

    &.child {
      border-top: none;
    }
  }

  .child-nav-item {
    // background-color: rgba(0, 8, 44, 0.57) !important;
    // padding-left: 16px;
    // border-top-right-radius: 0 !important;
    // border-top-left-radius: 0 !important;
    // margin: 0px 5px !important;
    background: none !important;
    border: none !important;
    padding-left: 20px;

    // &.outer {
    //   padding-left: 20px;
    //   padding-right: 25px;
    // }

    // &.top-level-child {
    //   background-color: rgba(0, 17, 44, 0.3) !important;
    // }
  }

  // .tree-nav {
  //   border-top: 1px solid rgb(135, 135, 135);;
  // }

  .v-list-item {
    border-radius: 0px 10px 10px 0px;
    // border: 1px solid #FFF;
  }

  .v-list-item--density-compact.v-list-item--one-line {
    min-height: 32px !important;
  }

  .v-list-item__title {
    font-size: 1rem !important;
    line-height: 1.1rem !important;
  }

  .v-list-item__icon {
    // margin-right: 15px !important;
    padding: 0px !important;
    margin: 0px 5px 0px 0px !important;
  }

  .v-list-item__content {
    padding: 0px !important;
  }

  .v-list-item-group .v-list-item--active {
    // background-color: #f6f7f9;
    border: 1px solid #e0e0e0;
  }

  // .v-list-item--active:before, .v-list-item--active:hover:before, .v-list-item:focus:before {
  //   opacity: 0;
  // }

  .nav-header-item {
    .v-list-item__icon {
      margin: 8px 5px 0px 0px !important;
    }
  }
}

</style>
